import React from "react";
import SidebarDisplay from "../../Display/Menu/SidebarDisplay";

const SidebarContainer = () => {
  return <SidebarDisplay />;
};

export default SidebarContainer;
